module.exports = __webpack_public_path__ + "static/media/profesoraUnidades.1bdde106.svg";